import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CustomLoader from "../../../../../../util/component/CustomLoader";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { execBookingAction, useBookingByIdWithMetaQueryObserver } from "../../../../api/services";
import DialogCloseButton from "../../../../components/DialogCloseButton";
import useDialog from "../../../../hooks/useDialog";
import { BookingAction, RouteParams } from "../../../../types";

const BookAction = () => {

    const { t } = useTranslation('booking');

    const { dispatchGlobalData } = useContext(GlobalContext);

    const { id } = useParams<RouteParams>();

    const dialog = useDialog();

    const bookingQuery = useBookingByIdWithMetaQueryObserver(id);

    const execBookingActionMutation = useMutation(
        execBookingAction,
        {
            onError: () => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('message.error.default'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            },
            onSuccess: (data) => {
                if (data.booking.blackList) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('message.warning.blacklisted'),
                                type: snackbarTypes.warning,
                                show: true,
                                autoClose: true,
                            }
                        }
                    })
                }
                bookingQuery.refetch();
            }
        }
    );

    const onClickConfirm = useCallback(() => {
        if (!bookingQuery.data) {
            return;
        }
        execBookingActionMutation.mutate({
            bookingId: bookingQuery.data.booking.id,
            action: BookingAction.Book,
            lastUpdateTime: bookingQuery.data.booking.requestUpdateDate
        });
    }, [bookingQuery.data]);

    return (
        <>
            {bookingQuery.data?.permissions.actions[BookingAction.Book] &&
                <>
                    <Button
                        onClick={dialog.handleShow}
                    >
                        {t('label.book')}
                    </Button>
                    <Dialog
                        open={dialog.open}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogCloseButton onClick={dialog.handleClose} />
                        <DialogTitle>
                            {t('label.statusChange')}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {t('message.info.confirm_offer_action')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="outlined"
                                onClick={dialog.handleClose}
                            >
                                {t('label.back')}
                            </Button>
                            <Button onClick={onClickConfirm}>
                                {t('label.save')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <CustomLoader loading={execBookingActionMutation.isLoading} />
                </>
            }
        </>
    );
};

export default BookAction;
